import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { Commission, Order } from '@shared-logic/orders';
import { setEditAll, setIndexToEdit, setIndexToEditValidation, setOrdersSelected, setValidationOrdersToGenerate } from 'src/app/redux/actions/order.action';
import { DateChecker } from '@shared-logic/utils';
import { OrderValidator } from 'src/app/shared/order';
import { Details } from '../details.component';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { orderCategory } from 'src/app/shared/dict/orders';
import { Subscription } from 'rxjs';
import { isBuyerOfGrassiGroup, applyOrderCommissionAndPort } from '@shared-logic/subjects';
import { ToFixValidator } from 'src/app/shared/to-fix';
import { ACTIONS_MANY_ORDERS, ActionOrderMany } from '../details-many-orders/details-many-orders.component';
import { IntegrationIBMService } from 'src/app/shared/services/integration-ibm.service';
import { PurchaseMethodValidationState } from 'src/app/shared/interfaces/order.interface';
import { purchaseMethodValidationInitialState } from 'src/app/shared/const/orders';
import { isPurchaseMethodGateBlocked } from '@shared-logic/purchase-method';
import { CREATION_TYPE_CONST } from '@shared-logic/prices';
import { isCramdownApplicable, isCramdownProductMismatch } from '@shared-logic/subjects/buyers-validations';

@Component({
  selector: 'details-validation',
  templateUrl: './details.component.html',
  styleUrls: ['./../details.scss']
})

export class DetailsValidationComponent extends Details implements OnInit, OnDestroy {
  nroOfCall: number = 1;
  isGenerateEraser: boolean = true;

  ORDER_TYPE_CATEGORY: any = orderCategory;

  purchaseMethodValidation: PurchaseMethodValidationState = purchaseMethodValidationInitialState;

  private orders$!: Subscription;
  private identificatorOrderEdit$!: Subscription;
  private isGenerateEraser$!: Subscription;
  private editAll$!: Subscription;
  private purchaseMethodValidation$!: Subscription;

  constructor(store: Store<appState>,
    private router: Router, dialog:
      MatDialog, date: DateChecker, orderV: OrderValidator, toFixV: ToFixValidator,
    private IBM: IntegrationIBMService) {
    super(store, dialog, date, orderV, toFixV);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.orders$ = this.store.select('order', 'edit', 'ordersEdit').subscribe(ordersEdit => {
      this.orders = ordersEdit;
      this.order = this.orders[this.identificatorOrderEdit];
      this.disabledButton = this.getIsOrdersIncompletes(this.orders);
    });

    this.identificatorOrderEdit$ = this.store.select('order', 'edit', 'indexToEdit').subscribe(indexToEdit => {
      this.identificatorOrderEdit = indexToEdit;
      this.order = this.orders[this.identificatorOrderEdit];
    });

    this.isGenerateEraser$ = this.store.select('order', 'edit', 'isGenerateEraser').subscribe(isGenerateEraser => {
      this.isGenerateEraser = isGenerateEraser;
      //Si estamos editando la orden por primera vez antes de generar borrador, es true
      //Si estamos editando la orden por segunda vez, para generar contrato, es false.
    });

    this.editAll$ = this.store.select('order', 'edit', 'editAll').subscribe(editAll => {
      this.editAllOrders = editAll;
    });

    this.purchaseMethodValidation$ = this.store.select('order', 'purchaseMethodValidation').subscribe(state => {
      this.purchaseMethodValidation = state;
      /* The verdict arrives on its own, later than the orders that were already loaded
      when the ordersEdit$ subscription last computed disabledButton (finding 03: this
      subscription used to store the state and never recompute anything from it). */
      this.disabledButton = this.getIsOrdersIncompletes(this.orders);
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.orders$?.unsubscribe();
    this.identificatorOrderEdit$?.unsubscribe();
    this.isGenerateEraser$?.unsubscribe();
    this.editAll$?.unsubscribe();
    this.purchaseMethodValidation$?.unsubscribe();
  }

  getIsOrdersIncompletes(orders: Order[]) {
    return orders.some(order => this.orderV.isOrderIncomplete(order) || this.isOrderPurchaseMethodBlocked(order) || this.isOrderCramdownProductMismatch(order));
  }

  /* R1/R6: the store holds one verdict for one pair, not one per order -- by design,
  since the whole batch normally shares a single buyer (R6). Checking every order's OWN
  pair against that same verdict is enough to catch the batch-with-more-than-one-pair
  case too (finding from editing a single order without editAll, R10): at most one
  order's pair can ever match the stored verdict at a time, so any other order in the
  lot is correctly seen as not yet proven and blocks the button. Purely a read of
  already-known data -- fires no query. */
  private isOrderPurchaseMethodBlocked(order: Order): boolean {
    return isPurchaseMethodGateBlocked(
      { buyerCode: order.price?.observations?.buyer ?? 0, purchaseMethod: order.purchaseMethod ?? 0 },
      this.purchaseMethodValidation
    );
  }

  /* Hard block (R4/R7, additive -- never replaces normalizeCramdown() below, which only
  decides the Marca). true when this order's own seller/buyer pair is Cramdown-eligible
  and its product isn't Soja, blocking confirmation of the whole batch, not just this
  order. Reads price.observations.buyer, the same field isOrderPurchaseMethodBlocked
  above already reads -- the buyer is already fixed at this stage of the flow, same
  pattern add-buyer.component.ts used for its own equivalent check (R1/R8). */
  private isOrderCramdownProductMismatch(order: Order): boolean {
    return isCramdownProductMismatch(
      order.sellerData.codeS,
      [order.price?.observations?.buyer ?? 0],
      order.price.productName
    );
  }

  editAllOrders: boolean = false;
  changeEditAllOrders(booleanToSet: boolean) {
    this.store.dispatch(setEditAll({ editAll: booleanToSet }));
  }

  override editOrder(index: number) {
    this.store.dispatch(setIndexToEditValidation({ indexToEdit: index }));
  }

  override setCommission(event: Commission, index: number) {
    let newOrders: Order[] = JSON.parse(JSON.stringify(this.orders)); //Parsed orders
    newOrders[index].commision = event;
    this.store.dispatch(setValidationOrdersToGenerate({ orders: newOrders })); //Set orders
  }

  override sendOrder() {
  }

  override sendOrders() {
    let newOrders = this.updateOrders(this.orders);

    if (this.isGenerateEraser) {
      //Depende del nro de call seleccionado antes (si el comprador es commodities o no)
      this.IBM.createContracts(newOrders, this.nroOfCall, this.user);
    } else {
      //Siempre se envía 2 porque significa que ingresamos desde otra sección
      this.IBM.createContracts(newOrders, 2, this.user);
    }

    this.goToOrderBoard();
  }

  goToOrderBoard() {
    const url = '/' + NAVEGATION.ORDER_BOARD
    this.router.navigate([url]);
    this.store.dispatch(setOrdersSelected({ orders: [] }));
    this.store.dispatch(setValidationOrdersToGenerate({ orders: [] }))
    this.store.dispatch(setIndexToEdit({ indexToEdit: 0 }))
    this.store.dispatch(setEditAll({ editAll: false }))
  }

  updateOrders(orders: Order[]) {
    let newOrders: Order[] = JSON.parse(JSON.stringify(orders));
    for (let i = 0; i < newOrders.length; i++) {
      this.setNroOfCall(newOrders[i]);
      const sellerCode = newOrders[i].sellerData.codeS;
      const buyerCode = newOrders[i].price.observations.buyer;
      newOrders[i].quotas = JSON.stringify(this.orderV.getValidQuotas(newOrders[i]));

      //Actualizamos las comisiones;
       newOrders[i] = applyOrderCommissionAndPort(
         newOrders[i],
         sellerCode,
        buyerCode,
         (order, type) => this.orderV.getCommisionByOrder(order, type)
       );

       newOrders[i] = this.normalizeCramdown(newOrders[i]);

    }

     return newOrders;
   }

  private normalizeCramdown(order: Order): Order {
    const creationType = isCramdownApplicable(
      order.sellerData.codeS,
      order.price.observations.buyer,
      order.price.productName
    )
      ? CREATION_TYPE_CONST.CRAMDOWN
      : CREATION_TYPE_CONST.STANDARD;

    if (order.price.creationType === creationType) {
      return order;
    }

    return {
      ...order,
      price: { ...order.price, creationType },
    };
  }

  haventBuyerInOrders(): boolean {
    return this.orders.some(order => order.price.observations.buyer <= 0);
  }

  setNroOfCall(order: Order) {
    //this.nroOfCall= (order.price.observations.buyer==COMMODITIES_CODE)?1:2;
    this.nroOfCall = (isBuyerOfGrassiGroup(order.price.observations.buyer)) ? 1 : 2;
  }

  recieveAction(actOrdMany: ActionOrderMany) {
    if (actOrdMany.action == ACTIONS_MANY_ORDERS.EDIT) {
      this.editOrder(actOrdMany.index);
    } else if (actOrdMany.action == ACTIONS_MANY_ORDERS.COMMISSION && actOrdMany.commission) {
      this.setCommission(actOrdMany.commission, actOrdMany.index);
    }
  }
}
